import { createFileRoute } from "@tanstack/react-router";
import { listingSitemapRoute } from "@/lib/core/sitemaps";

export const Route = createFileRoute("/sitemaps/dogs-{$page}.xml")({
    ...listingSitemapRoute,
});
